module.exports = __webpack_public_path__ + "static/media/amenity-wifi.3895c53e.svg";